interface PlanFeature {
  label: string;
  included: boolean;
}

interface PlanCardProps {
  id: string;
  name: string;
  price: string;
  features: PlanFeature[];
  isPopular?: boolean;
  ctaLabel: string;
  onSelect: () => void;
  isLoading?: boolean;
  isEnterprise?: boolean;
  ctaHref?: string;
}

export function PlanCard({
  name,
  price,
  features,
  isPopular,
  ctaLabel,
  onSelect,
  isLoading,
  isEnterprise,
  ctaHref,
}: PlanCardProps) {
  const cardClasses = `plan-card${isPopular ? " plan-card--popular" : ""}`;
  const isFree = price === "€0";

  return (
    <div className={cardClasses}>
      {isPopular && <div className="plan-card__badge">Most Popular</div>}
      <h3 className="plan-card__name">{name}</h3>
      <div className="plan-card__price">{price}</div>
      {!isEnterprise && !isFree && (
        <div className="plan-card__price-description">billed monthly</div>
      )}
      {isFree && (
        <div className="plan-card__price-description">no credit card needed</div>
      )}
      <ul className="plan-card__features">
        {features.map((f) => (
          <li
            key={f.label}
            className={`plan-card__feature${f.included ? "" : " plan-card__feature--excluded"}`}
          >
            <span className="plan-card__feature-icon" aria-hidden="true">
              {f.included ? "\u2713" : "\u2717"}
            </span>{" "}
            {f.label}
          </li>
        ))}
      </ul>
      <div className="plan-card__cta">
        {isEnterprise && ctaHref ? (
          <a
            href={ctaHref}
            className="btn btn--secondary"
            style={{ display: "block", textAlign: "center" }}
          >
            {ctaLabel}
          </a>
        ) : (
          <button
            type="button"
            className={`btn btn--full ${isEnterprise ? "btn--secondary" : "btn--primary"}`}
            onClick={onSelect}
            disabled={isLoading}
          >
            {isLoading ? "Loading\u2026" : ctaLabel}
          </button>
        )}
      </div>
    </div>
  );
}
